import React, { memo } from 'react';

import styles from './Panel.module.scss';

export const Panel = memo(
  ({
    children,
    title,
    footer,
    name,
  }: {
    children: React.ReactNode;
    title?: string;
    footer?: React.ReactNode;
    name?: string;
  }) => {
    const sanitizedTitle = title?.replace('facets.', '');

    return (
      <div className={styles.panel} data-name={`fallback-${name}`}>
        {title && <b className={styles.facetTitle}>{sanitizedTitle}</b>}
        {children}
        {footer && <div className={styles.facetFooter}>{footer}</div>}
      </div>
    );
  }
);
